import React, { useRef, useState, useContext, useEffect } from "react";
import CX from "classnames";
import Space from "antd/es/space";
import Table from "antd/es/table";

import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { TipsContext } from "@/context";
import { getYYMMDDHHMM } from "@/utils";
import { getUserList, deleteUser, updateUserInfo } from "@/server/userManager";
import { getModuleList } from "@/server/moduleManager";
import "./index.less";

export default function UserAccount() {
  const [userList, setUserList] = useState([]);
  const [moduleList, setModuleList] = useState({});
  const [currentType, setCurrentType] = useState(0);
  const [showModules, setShowModules] = useState(false);
  const { useModal, useMessage } = useContext(TipsContext);
  const { modal } = useModal();
  const [currentUserMsg, setCurrentUserMsg] = useState({
    code: "",
    user_name: "",
    password: "",
    shop_id: "",
    create_time: "",
    whitelist: [],
  });
  const columns = useRef([
    {
      title: "编号",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "用户名",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "店铺ID",
      dataIndex: "shop_id",
      key: "shop_id",
    },
    {
      title: "注册时间",
      dataIndex: "create_time",
      key: "create_time",
    },
    {
      title: "操作",
      dataIndex: "handle",
      key: "handle",
      render: (_) => {
        return (
          <Space size={24}>
            <div
              className="text"
              onClick={() => {
                modal({
                  title: "密码:",
                  content: _.password,
                });
              }}
            >
              查看密码
            </div>
            <div className="line"></div>
            <div
              className="text"
              onClick={() => {
                setCurrentUserMsg(_);
                setShowModules(true);
              }}
            >
              管理权限
            </div>
            <div className="line"></div>
            <div
              className="text red"
              onClick={() => {
                const isOk = window.confirm("确定要删除该账号？");
                if (isOk) {
                  deleteUser(_.user_id).then(() => {
                    useMessage.success("删除成功");
                    getNewUserList();
                  });
                }
              }}
            >
              删除账号
            </div>
          </Space>
        );
      },
    },
  ]);

  const getNewUserList = () => {
    return getUserList().then((res) => {
      res = res.map((item, index) => {
        item.code = index + 1;
        item.key = index + 1 + "";
        item.create_time = getYYMMDDHHMM(item.create_time);
        item.handle = {
          ...item,
          whitelist: JSON.parse(item.whitelist),
        };
        return item;
      });
      setUserList(res);
    });
  };

  useEffect(() => {
    getNewUserList();
  }, []);

  useEffect(() => {
    const result = {};
    getModuleList().then((res) => {
      if (res.length === 0) return;
      res.forEach((item) => {
        if (!result[item.class]) {
          result[item.class] = [];
          result[item.class].push(item);
        } else if (result[item.class]) {
          result[item.class].push(item);
        }
      });
      setCurrentType(Object.keys(result)[0]);
      setModuleList(result);
    });
  }, []);

  return (
    <div className="user-manager-wrap items-center justify-center">
      {showModules && Object.keys(moduleList).length > 0 && (
        <div className="float-content justify-center items-center">
          <div className="module-list flex-row justify-center">
            <div
              style={{
                height: 678,
                borderRight: "1px solid #DEDEDE",
              }}
            >
              <div className="title">模块类别</div>
              <div className="content flex-col">
                {Object.keys(moduleList).map((m, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        setCurrentType(m);
                      }}
                      className={CX({
                        "scroll-item": true,
                        active: currentType === m,
                      })}
                    >
                      {m}
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{
                height: 678,
                borderRight: "1px solid #DEDEDE",
              }}
            >
              <div className="title-area">
                <div className="title module">模块名称</div>
                <div className="title module">权限</div>
              </div>
              <div className="main-content">
                <div className="content module">
                  {moduleList[currentType].map((m, index) => {
                    return (
                      <div
                        key={"m" + index}
                        className="scroll-item justify-around"
                      >
                        {m.name}
                      </div>
                    );
                  })}
                </div>
                <div className="content">
                  {moduleList[currentType].map((m, index) => {
                    const isLock = !currentUserMsg.whitelist.includes(m.name);
                    return (
                      <div key={"l" + index} className="scroll-item">
                        <Space size={22}>
                          <LockOutlined
                            style={{
                              fontSize: 20,
                              color: isLock ? "#FF0E0E" : "#DEDEDE",
                            }}
                            onClick={() => {
                              // 锁定
                              if (isLock) return;
                              const newWhitelist = [
                                ...currentUserMsg.whitelist,
                              ];
                              newWhitelist.splice(
                                newWhitelist.indexOf(m.name),
                                1
                              );
                              setCurrentUserMsg({
                                ...currentUserMsg,
                                whitelist: newWhitelist,
                              });
                            }}
                          />
                          <UnlockOutlined
                            style={{
                              fontSize: 20,
                              color: isLock ? "#DEDEDE" : "#25C352",
                            }}
                            onClick={() => {
                              // 解锁
                              if (!isLock) return;
                              const newWhitelist = [
                                ...currentUserMsg.whitelist,
                              ];
                              newWhitelist.push(m.name);
                              setCurrentUserMsg({
                                ...currentUserMsg,
                                whitelist: newWhitelist,
                              });
                            }}
                          />
                        </Space>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div
              className="save"
              onClick={() => {
                updateUserInfo(currentUserMsg.user_id, currentUserMsg).then(
                  () => {
                    getNewUserList().then(() => {
                      setShowModules(false);
                    });
                  }
                );
              }}
            >
              保存
            </div>
          </div>
        </div>
      )}

      <Table columns={columns.current} dataSource={userList} />
    </div>
  );
}
